import { useState, useEffect } from 'react';

import { getFiscalQr } from 'services/payments-service';
import { Loader2, Popup2 } from 'libs/ui';
import { Content, Error } from './qr.styled';

export const Qr = (props) => {
  const { close, id } = props;

  const [ready, setReady] = useState(false);
  const [qr, setQr] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    getFiscalQr(id)
      .then((data) => {
        if (!data) {
          setQr('');
          setError('QR по данной операции отсутствует');
        } else {
          setQr(data);
          setError('');
        }
      })
      .catch((error) => {
        setQr('');
        setError(error.toString());
      })
      .finally(() => {
        setReady(true);
      });
  }, [id]);

  const closePopup = () => {
    close();
  };

  const fn = 'data:image/png;base64,' + qr;
  return (
    <Popup2 close={closePopup} w={320}>
      <Content>{!ready ? <Loader2 height={'250px'} /> : error ? <Error>{error}</Error> : <img src={fn} alt={'qr'} />}</Content>
    </Popup2>
  );
};
